import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Settings";
import Auth from "./auth.reducer";
import MasterData from "./master_data.reducer";
import General from "./general.reducer";
import Contents from "./contents.reducer";
import health_partnersReducer from "./health_partners.reducer";
import usersReducer from "./users.reducer";
import patientaReducer from "./patients.reducer";
import doctorReducer from "./doctors.reducer";
import subscriptionsReducer from "./subscriptions.reducer";
import paymentsReducer from "./payments.reducer";
import featuresReducer from "./features.reducer";
import packsReducer from "./packs.reducer";
import businessesReducer from "./businesses.reducer";
import promotionReducer from "./promotions.reducer";
import consultationsnReducer from "./consultations.reducer";
import doctorShiftInfo from "./doctorShift.reducer";
import schedularInfo from "./schedular.reducer";
import doctorLeaveInfo from "./doctorLeave.reducer";
import newConsultaionInfo from "./new.consulation.reducer"; 
import tanentInfo from "./tanent.reducer";


export default (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    auth: Auth,
    master_data: MasterData,
    general: General,
    contents_: Contents,
    h_p: health_partnersReducer,
    users_r: usersReducer,
    patients_r: patientaReducer,
    doctors_r: doctorReducer,
    subscriptions_r: subscriptionsReducer,
    payments_r: paymentsReducer,
    features_r: featuresReducer,
    packs_r: packsReducer,
    businesses_r: businessesReducer,
    promotions_r: promotionReducer,
    consultation_r: consultationsnReducer,
    doctor_shift_r: doctorShiftInfo,
    schedular_r: schedularInfo,
    doctor_leave_r: doctorLeaveInfo,
    new_consultaion_r: newConsultaionInfo,
    tanent_r: tanentInfo,
  });
